import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const LibraryIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" {...props}>
    <Path
      d="M2 5.5 8 2l6 3.5H2ZM3 7.5v4M6.5 7.5v4M9.5 7.5v4M13 7.5v4M2 13.5h12"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
